import React, { useState } from 'react';
import { addMonths, format, isSameDay, isSameMonth, startOfMonth } from 'date-fns';
import Icon from '../../components/Icon';
import { dateLocale, hasEvents, monthMatrix, weekdayLabels } from '../calendarUtils';

// Мини-календарь в боковой колонке: точка под днём — есть события.
const MiniCalendar = ({ value, events, locale, onSelect }) => {
  const [month, setMonth] = useState(() => startOfMonth(value));
  const days = monthMatrix(month);

  return (
    <div className="cal-mini">
      <div className="cal-mini-head">
        <button type="button" className="cal-icon-btn" onClick={() => setMonth(addMonths(month, -1))}>
          <Icon name="chevron-left" size={16} />
        </button>
        <span className="cal-mini-title">
          {format(month, 'LLLL yyyy', { locale: dateLocale(locale) })}
        </span>
        <button type="button" className="cal-icon-btn" onClick={() => setMonth(addMonths(month, 1))}>
          <Icon name="chevron-right" size={16} />
        </button>
      </div>

      <div className="cal-mini-grid">
        {weekdayLabels(locale).map((label) => (
          <span className="cal-mini-weekday" key={label}>{label.slice(0, 2)}</span>
        ))}

        {days.map((day) => {
          const outside = !isSameMonth(day, month);
          const selected = isSameDay(day, value);
          return (
            <button
              key={day.toISOString()}
              type="button"
              className={`cal-mini-day${outside ? ' outside' : ''}${selected ? ' selected' : ''}`}
              onClick={() => onSelect(day)}
            >
              {format(day, 'd')}
              {hasEvents(events, day) && <span className="cal-mini-dot" />}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default MiniCalendar;
